export const locale = [
  {
    parentKey: "scale2_0",
    translations: {
      nl_BE: { translation: "(0) Niet" },
      fr_BE: { translation: "(0) Pas du tout" },
      en_GB: { translation: "(0) Not at all" }
    }
  },
  {
    parentKey: "scale2_inverse_0",
    translations: {
      nl_BE: { translation: "Veel" },
      fr_BE: { translation: "Beaucoup" },
      en_GB: { translation: "A lot" }
    }
  },
  {
    parentKey: "disclaimer",
    translations: {
      nl_BE: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      fr_BE: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      tr_TR: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      sh_SH: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      sk_SK: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      pl_PL: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      en_GB: { translation: "I agree with the privacy conditions" },
      bg_BG: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      ar_SA: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      ru_RU: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      es_ES: { translation: "Ik ga akkoord met de privacy voorwaarden" },
      sq_AL: { translation: "Ik ga akkoord met de privacy voorwaarden" }
    }
  },
  {
    parentKey: "disclaimer_body",
    translations: {
      nl_BE: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      fr_BE: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      tr_TR: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      sh_SH: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      sk_SK: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      pl_PL: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      en_GB: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      bg_BG: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      ar_SA: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      ru_RU: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      es_ES: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      },
      sq_AL: {
        translation:
          "Je gegevens worden aan ons databestand toegevoegd en (geanonimiseerd) opgenomen in de grafieken, enkel gebruikt in het kader van wetenschappelijk onderzoek en worden onder geen beding doorgespeeld aan derden of gebruikt voor commerciële doeleinden. De gegevens van individuele leerkrachten worden ten alle tijde anoniem verwerkt. De gegevens op het niveau van de school worden enkel vrij-gegeven wanneer een school hier uitdrukkelijk de toestemming voor geeft."
      }
    }
  },
  {
    parentKey: "register_register_title",
    translations: {
      nl_BE: { translation: "Registratie" },
      fr_BE: { translation: "Enregistrement" },
      en_GB: { translation: "Registration" }
    }
  },
  {
    parentKey: "register_register_body",
    translations: {
      nl_BE: {
        translation:
          "U dient zich eerst te registreren om DISCO individueel in te vullen of naar een groep uit te sturen."
      },
      fr_BE: {
        translation:
          "Vous devez d'abord vous enregistrer pour compléter DISCO individuellement ou pour l'envoyer à un groupe."
      },
      en_GB: {
        translation:
          "You must first register in order to fill out DISCO individually or send it to a group."
      }
    }
  },
  {
    parentKey: "survey_view_for_group",
    translations: {
      nl_BE: { translation: "U vult deze vragenlijst in voor" },
      fr_BE: { translation: "Vous remplissez ce questionnaire pour" },
      en_GB: { translation: "You are filling in this questionnaire for" }
    }
  },
  {
    parentKey: "send",
    translations: {
      nl_BE: { translation: "Verzend" },
      fr_BE: { translation: "Envoyez" },
      en_GB: { translation: "Send" }
    }
  },
  {
    parentKey: "register_register_group_description",
    translations: {
      nl_BE: {
        translation:
          "Wilt u DISCO door een groep laten invullen (om bv. zicht te krijgen op de gemiddelde resultaten van een schoolteam), geef dan in onderstaand veld de naam van de groep waarvan u de resultaten wilt bundelen. Laat het veld leeg indien u DISCO individueel wilt invullen."
      },
      fr_BE: {
        translation:
          "Si vous souhaitez que DISCO soit rempli par un groupe (par exemple pour avoir une idée des résultats moyens d'une équipe scolaire), entrez le nom du groupe dont vous souhaitez combiner les résultats dans le cadre ci-dessous. Laissez le cadre vide si vous voulez remplir DISCO individuellement."
      },
      en_GB: {
        translation:
          "If you would like DISCO to be filled in by a group (e.g. to get an idea of the average results of a school team), enter the name of the group whose results you would like to combine in the field below. Leave the field empty if you want to fill in DISCO individually."
      }
    }
  },
  {
    parentKey: "register_register_group_enable",
    translations: {
      nl_BE: { translation: "DISCO als school/groep invullen?" },
      fr_BE: { translation: "Remplir DISCO en tant qu'école/groupe?" },
      en_GB: { translation: "Fill in DISCO as a school/group?" }
    }
  },
  {
    parentKey: "register_register_btn_label",
    translations: {
      nl_BE: { translation: "Registreren" },
      fr_BE: { translation: "Enregistrer" },
      en_GB: { translation: "Register" }
    }
  },
  {
    parentKey: "cancel",
    translations: {
      nl_BE: { translation: "Annuleren" },
      fr_BE: { translation: "Annuler" },
      en_GB: { translation: "Cancel" }
    }
  },
  {
    parentKey: "send",
    translations: {
      nl_BE: { translation: "versturen" },
      fr_BE: { translation: "envoyer" },
      en_GB: { translation: "send" }
    }
  },
  {
    parentKey: "register_success_title",
    translations: {
      nl_BE: { translation: "Uw gegevens zijn goed ontvangen." },
      fr_BE: { translation: "Vos données ont été bien reçues" },
      en_GB: { translation: "Your details have been well received" }
    }
  },
  {
    parentKey: "register_success_text",
    translations: {
      nl_BE: {
        translation:
          "Er werd een verificatiemail verstuurd naar het e-mailadres dat aan uw account gekoppeld is. Van zodra het emailadres is bevestigd, kan u aan de slag."
      },
      fr_BE: {
        translation:
          "Un e-mail de vérification a été envoyé à l'adresse e-mail associée à votre profil. Dès que l'adresse e-mail a été confirmée, vous pouvez commencer."
      },
      en_GB: {
        translation:
          "A verification email was sent to the email address associated with your account. As soon as the email address has been confirmed, you can get started."
      }
    }
  },
  {
    parentKey: "validation_valueMissing",
    translations: {
      nl_BE: { translation: "Dit veld is verplicht in te vullen" },
      fr_BE: { translation: "Ce cadre est obligatoire" },
      en_GB: { translation: "This field is mandatory" }
    }
  },
  {
    parentKey: "validation_globaleMessage",
    translations: {
      nl_BE: { translation: "Niet alle velden zijn (correct) ingevuld." },
      fr_BE: {
        translation: "Tous les cadres ne sont pas (correctement) remplis."
      },
      en_GB: { translation: "Not all fields are (correctly) filled in." }
    }
  },
  {
    parentKey: "next",
    translations: {
      nl_BE: { translation: "Volgende" },
      fr_BE: { translation: "Suivant" },
      en_GB: { translation: "Next" }
    }
  },
  {
    parentKey: "previous",
    translations: {
      nl_BE: { translation: "Vorige" },
      fr_BE: { translation: "Précédent" },
      en_GB: { translation: "Previous" }
    }
  },
  {
    parentKey: "barometer_app_link_label",
    translations: {
      nl_BE: { translation: "- Deze enquête werd gemaakt met BAROMETER -" },
      fr_BE: { translation: "- Cette enquête a été réalisée avec BAROMETER -" },
      en_GB: { translation: "- This questionnaire was made with BAROMETER -" }
    }
  },
  {
    parentKey: "user_password_reset_title",
    translations: {
      nl_BE: { translation: "Wachtwoord vergeten?" },
      fr_BE: { translation: "Mot de passe oublié?" },
      en_GB: { translation: "Forgot your password?" }
    }
  },
  {
    parentKey: "user_password_reset_body",
    translations: {
      nl_BE: {
        translation:
          "Vul hieronder uw e-mailadres in, we sturen u daarna een link waarmee u een nieuw wachtwoord kunt aanmaken."
      },
      fr_BE: {
        translation:
          "Entrez votre adresse email ci-dessous et nous vous enverrons un lien pour créer un nouveau mot de passe."
      },
      en_GB: {
        translation:
          "Enter your email address below and we will send you a link to create a new password."
      }
    }
  },
  {
    parentKey: "user_password_reset_success",
    translations: {
      nl_BE: { translation: "Een email werd verzonden naar" },
      fr_BE: { translation: "Un email a été envoyé à" },
      en_GB: { translation: "An email was sent to" }
    }
  },

  {
    parentKey: "user_logged_in",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Je bent ingelogd"
      },
      fr_BE: {
        language: "fr_be",
        translation: ""
      },
      en_GB: {
        language: "en_gb",
        translation: "You are logged in"
      }
    }
  },
  {
    parentKey: "user_signin",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Aanmelden"
      },
      fr_BE: {
        language: "fr_be",
        translation: "Sign in"
      },
      en_GB: {
        language: "en_gb",
        translation: "Sign in"
      }
    }
  },
  {
    parentKey: "email",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "E-mail"
      },
      fr_BE: {
        language: "fr_be",
        translation: "E-mail"
      },
      en_GB: {
        language: "en_gb",
        translation: "E-mail"
      }
    }
  },
  {
    parentKey: "password",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Wachtwoord"
      },
      fr_BE: {
        language: "fr_be",
        translation: "Mot de passe"
      },
      en_GB: {
        language: "en_gb",
        translation: "Password"
      }
    }
  },
  {
    parentKey: "password_register",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Wachtwoord (minimum 6 tekens)"
      },
      fr_BE: {
        language: "fr_be",
        translation: "Mot de passe (minimum 6 caractères)"
      },
      en_GB: {
        language: "en_gb",
        translation: "Password (minimum 6 characters)"
      }
    }
  },
  {
    parentKey: "password_confirm",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Bevestig wachtwoord"
      },
      fr_BE: {
        language: "fr_be",
        translation: "Confirmer le mot de passe"
      },
      en_GB: {
        language: "en_gb",
        translation: "Confirm password"
      }
    }
  },
  {
    parentKey: "group_name",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Groepsnaam"
      },
      fr_BE: {
        language: "fr_be",
        translation: "Nom du groupe"
      },
      en_GB: {
        language: "en_gb",
        translation: "Name of the group"
      }
    }
  },
  {
    parentKey: "group_name_placeholder",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Bv. naam van school, campus, ..."
      },
      fr_BE: {
        language: "fr_be",
        translation: " "
      },
      en_GB: {
        language: "en_gb",
        translation: " "
      }
    }
  },
  {
    parentKey: "boarding_title",
    translations: {
      nl_BE: { translation: "Welkom op de DISCO-groepspagina" },
      fr_BE: { translation: "Bienvenue sur votre page de groupe DISCO" },
      en_GB: { translation: "Welcome to your DISCO group page" }
    }
  },
  {
    parentKey: "boarding_body",
    translations: {
      nl_BE: {
        translation:
          "Op deze pagina vindt u de DISCO-vragenlijst. Als groepsverantwoordelijke kan u deze vragenlijst delen of de resultaten bekijken."
      },
      fr_BE: {
        translation:
          "Sur cette page vous trouverez le questionnaire DISCO. Cliquez sur ce questionnaire pour partager le questionnaire ou pour voir les résultats."
      },
      en_GB: {
        translation:
          "On this page you will find the DISCO questionnaire. Click on this questionnaire to share the questionnaire or to view the results."
      }
    }
  },
  {
    parentKey: "start_title",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "ONTDEK JOUW UNIEKE DISCO-PROFIEL"
      },
      fr_BE: {
        language: "fr_be",
        translation: "DECOUVREZ VOTRE PROFIL DISCO"
      },
      en_GB: {
        language: "en_gb",
        translation: "DISCOVER YOUR DISCO-PROFILE"
      }
    }
  },
  {
    parentKey: "start_description",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation:
          "Diversiteitsscreening onderwijs is een meet- en reflectie-instrument dat **leerkrachten** hun houding en competentiegevoel inzake omgaan met diversiteit in het onderwijs in kaart brengt."
      },
      fr_BE: {
        language: "fr_be",
        translation:
          "Disco est un outil de mesure et de réflexion qui montre ** les enseignants ** à leur attitude et à leur sens des compétences pour faire face à la diversité dans l’éducation."
      },
      en_GB: {
        language: "en_gb",
        translation:
          "Disco is a measurement and reflection tool that shows ** teachers ** their attitude and sense of competence with regard to dealing with diversity in education."
      }
    }
  },
  {
    parentKey: "start_disclaimer",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation:
          "* Het invullen van DISCO neemt gemiddeld een 20-tal minuten in beslag. Afhankelijk van hoe lang je stilstaat bij elke stelling, kan dit natuurlijk iets langer of korter duren. De gegevens worden anoniem verwerkt en je krijgt meteen na het invullen van de vragenlijst persoonlijke feedback."
      },
      fr_BE: {
        language: "fr_be",
        translation: ""
      },
      en_GB: {
        language: "en_gb",
        translation: ""
      }
    }
  }
];
